const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function normalize(value: string | null | undefined): string {
  return value?.trim() ?? "";
}

export function isTenantIdentifierLike(value: string | null | undefined): boolean {
  const normalized = normalize(value);
  if (!normalized) {
    return false;
  }
  return UUID_REGEX.test(normalized) || normalized.startsWith("tenant_");
}

function isUsableWorkspaceLabel(value: string | null | undefined, tenantId: string): boolean {
  const normalized = normalize(value);
  if (!normalized) {
    return false;
  }
  if (isTenantIdentifierLike(normalized)) {
    return false;
  }
  if (normalize(tenantId) === normalized) {
    return false;
  }
  return true;
}

export function resolveWorkspaceDisplayName(
  tenantId: string | null | undefined,
  candidates: Array<string | null | undefined>,
  fallback = "Workspace",
): string {
  const resolvedTenantId = normalize(tenantId);
  for (const candidate of candidates) {
    if (isUsableWorkspaceLabel(candidate, resolvedTenantId)) {
      return normalize(candidate);
    }
  }
  return fallback;
}
